import type { TypedAction } from "../../../../generic/redux/TypedRedux";

export const CLEAR_STACK_PACKS_PAGE_STATE = "@p-stack-packs/CLEAR_STATE";

export type ClearStackPacksPageState = TypedAction<typeof CLEAR_STACK_PACKS_PAGE_STATE>;

export const clearStackPacksPageState = (): ClearStackPacksPageState => ({
	type: CLEAR_STACK_PACKS_PAGE_STATE,
});
